import { MdsOption } from '@medpacesoftwaredevelopment/designsystem';
export interface Country extends CountryDto {
    id: number;
    isActive: boolean;
    name: string;
    numericCode: number;
    threeCharCode: string;
    twoCharCode: string;
    regionType: string;
    currencyIsoCode: string;
}

export interface CountryDto {
    id: number;
    name: string;
}

export class CountryViewModel implements MdsOption {
    id: number;
    value: unknown;
    viewValue: string;
    countryCode: string;
    currencyIsoCode: string;
    constructor(init?: Partial<CountryViewModel>) {
        if (init) Object.assign(this, init);
    }
}
